// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import axios from "axios";
import store from './store/index'
import 'element-ui/lib/theme-chalk/index.css';
import pako from 'pako'
Vue.use(pako)

//水印
// import  '@/utils/watermark'

axios.defaults.headers['Content-Type'] = 'application/x-www-form-urlencoded';

// 手机监控台
// import Vconsole from 'vconsole';
// new Vconsole();

// vant的全局提示
import { Toast } from 'vant';
Vue.use(Toast)

// 注册全局loading
import directives from './directives'
Vue.use(directives)

// 定义防重指令
Vue.directive("preventReClick", {
  inserted(el, binding) {
    el.addEventListener("click", () => {
      if (el.style.pointerEvents !== "none") {
        el.style.pointerEvents = "none"
        setTimeout(() => {
          el.style.pointerEvents = ""
        }, 2000)
      }
    })
  }
})

import positionAdjust from './utils/keyboard'
Vue.directive('positionAdjust', positionAdjust)

// vant的时间选择器
import { DatetimePicker } from 'vant';
Vue.use(DatetimePicker);
import 'vant/lib/index.css'


// 全局使用ws
import global from './utils/global.js';
Vue.prototype.global = global

// 转换时间戳
import {getTime} from '@/utils/getdate.js'
Vue.prototype.getTime = getTime

Vue.config.productionTip = false

// 登录拦截
router.beforeEach((to, from, next) => {
  if(sessionStorage.getItem("store") == 'true' || store.state.login || sessionStorage.getItem("mnstore") == 'true' || store.state.mnlogin){ //如果有就直接到首页咯
    next();
  } else {
      if(to.path=='/login'){ //如果是登录页面路径，就直接next()
          next();
      } else { //不然就跳转到登录；
          next('/login');
      }
  }
});

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js